module.exports = { id: "cargo-bike", url: "/build/app/img/symbols.svg#cargo-bike", viewBox: "", toString: function() { return this.url; } };